import React, { useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';
import admissionDefault from '../../../../data/admission/admission.json';

const AdmissionFAQ = ({ data }) => {
    const d = data || admissionDefault.faq;
    const [expandedIndex, setExpandedIndex] = useState(null);

    const faqs = d.items || [];

    const toggleFAQ = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 15 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.4 } }
    };

    return (
        <Box sx={{ mb: 8 }}>
            <Box sx={{ mb: 6, textAlign: 'center' }}>
                <Typography component="span" sx={{ fontSize: { xs: '0.75rem', md: '0.875rem' }, fontWeight: 900, letterSpacing: '0.2em', textTransform: 'uppercase', display: 'block', mb: 2, color: '#F6872A' }}>
                    {d.eyebrow}
                </Typography>
                <Typography component="h2" sx={{ fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' }, fontWeight: 900, letterSpacing: '-0.025em', mb: 3, lineHeight: 1.2, color: '#0e2455' }}>
                    {d.title}
                </Typography>
                <Typography component="p" sx={{ fontSize: { xs: '1rem', md: '1.125rem' }, fontWeight: 500, lineHeight: 1.6, color: '#64748B', maxWidth: '600px', mx: 'auto' }}>
                    {d.subtitle}
                </Typography>
            </Box>

            <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-50px" }}>
                <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
                    {faqs.map((faq, index) => {
                        const isExpanded = expandedIndex === index;
                        return (
                            <motion.div variants={itemVariants} key={index}>
                                <Paper
                                    elevation={0}
                                    onClick={() => toggleFAQ(index)}
                                    sx={{
                                        p: { xs: 3, md: 4 },
                                        mb: 2,
                                        borderRadius: '16px',
                                        border: '1px solid #E2E8F0',
                                        background: '#ffffff',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
                                            borderColor: '#CBD5E1'
                                        }
                                    }}
                                >
                                    {isExpanded && (
                                        <Box sx={{ position: 'absolute', top: '50%', left: 0, transform: 'translateY(-50%)', width: '4px', height: '40px', background: '#F6872A', borderRadius: '0 4px 4px 0' }} />
                                    )}

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pl: isExpanded ? 2 : 0, transition: 'padding 0.3s' }}>
                                        <Typography sx={{ color: '#0e2455', fontWeight: 800, fontSize: { xs: '1rem', md: '1.1rem' }, pr: 2 }}>
                                            {faq.q}
                                        </Typography>
                                        <Box
                                            sx={{
                                                flexShrink: 0,
                                                width: 36,
                                                height: 36,
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                background: isExpanded ? '#0e2455' : 'rgba(246,135,42,0.12)',
                                                color: isExpanded ? '#ffffff' : '#F6872A',
                                                transition: 'all 0.3s ease'
                                            }}
                                        >
                                            {isExpanded ? <FaMinus size="14px" /> : <FaPlus size="14px" />}
                                        </Box>
                                    </Box>
                                    
                                    <AnimatePresence>
                                        {isExpanded && (
                                            <motion.div
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: 'auto' }}
                                                exit={{ opacity: 0, height: 0 }}
                                                transition={{ duration: 0.3 }}
                                            >
                                                <Typography sx={{ color: '#64748B', fontSize: '0.95rem', lineHeight: 1.6, mt: 2, pl: 2 }}>
                                                    {faq.a}
                                                </Typography>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </Paper>
                            </motion.div>
                        );
                    })}
                </Box>
            </motion.div>
        </Box>
    );
};

export default AdmissionFAQ;
